<template>
  <div style="padding-top: 2vw;">
    <!-- <div class="search" @click="see">
      <i class="el-icon-search"></i>
      <i class="glyphicon del"></i>
      <span>搜索你想了解的病种</span>
    </div> -->
    <div class="search"  @click="see">
      <i class="el-icon-search" @click="see"></i>
      <i class="glyphicon del" @click="see"></i>
      <input @click="see" disabled style="background-color: #f6f6f6;margin-left: 15px;" type="text" @input="handleInput()" v-model="mytext" placeholder="搜索你想了解的病种" >
    </div>
    <div style="padding: 2vw 5vw;position: relative;">
      疾病类型
      <div style="width: 6vw;
    height: 1vw;
    background: rgb(34, 192, 137);
    border-radius: 100px;
    position: absolute;
    left: 11vw;
    bottom: 0vw;"></div>
    </div>
    <div class="tab-slider">
      <div class="tab">
        <div
        style="text-align: center;height: 15vw;line-height: 15vw;font-size: 4.5vw;color: gray;"
          v-for="(item, index) in list"
          v-bind:class="{ active: actived == index }"
          @click="toggle(index)"
        >
          {{ item.classify }}
        </div>
      </div>
      <div class="tab-content">
        <div class="wrapbox clearboth">
          <div style="padding-left: 5vw;" class="item" v-for="(item, index) in list" v-if="actived == index">
               <ul>
                <li style="padding: 4.2vw 0vw;font-size: 4.5vw;" v-for="(items, index) in item.typeNames" @click="details(items)">
                  {{items}}
                </li>
               </ul>
          </div>
        </div>
      </div>
    </div>
    <div style="font-size: 14px;">来源：<span style="color:#409eff" @click="xhjk">小荷健康</span></div>
    <div style="color:#409eff;font-size: 14px;padding-left: 6vw;" @click="xhjk">https://m.xiaohe-jiankang.com/medical/disease/list/1?open_time=1716778545650&last_page_item_id=</div>
     <div style="font-size: 12px;color: #ccc;">平台内容来自网络，转载已标明出处，如有侵权请联系我们立删。</div>
  </div>
</template>
<script>
import { medicalcanonv1info } from '@/api/activity'
export default {
  data() {
    return {
      list: [
        {
          name: "心脏病",
          ItemList: [{ itemName: "心脏病类型", age: "100人查看" }],
        },
        {
          name: "心脏病1",
          ItemList: [{ itemName: "心脏病类型2", age: "102人查看" }],
        },
        {
          name: "心脏病",
          ItemList: [{ itemName: "心脏病类型", age: "100人查看" }],
        },
        {
          name: "心脏病1",
          ItemList: [{ itemName: "心脏病类型2", age: "102人查看" }],
        },
        {
          name: "心脏病",
          ItemList: [{ itemName: "心脏病类型", age: "100人查看" }],
        },
        {
          name: "心脏病1",
          ItemList: [{ itemName: "心脏病类型2", age: "102人查看" }],
        },
        {
          name: "心脏病",
          ItemList: [{ itemName: "心脏病类型", age: "100人查看" }],
        },
        {
          name: "心脏病1",
          ItemList: [{ itemName: "心脏病类型2", age: "102人查看" }],
        },
        {
          name: "心脏病",
          ItemList: [{ itemName: "心脏病类型", age: "100人查看" }],
        },
        {
          name: "心脏病1",
          ItemList: [{ itemName: "心脏病类型2", age: "102人查看" }],
        },
        {
          name: "心脏病",
          ItemList: [{ itemName: "心脏病类型", age: "100人查看" }],
        },
        {
          name: "心脏病1",
          ItemList: [{ itemName: "心脏病类型2", age: "102人查看" }],
        },
        {
          name: "心脏病",
          ItemList: [{ itemName: "心脏病类型", age: "100人查看" }],
        },
        {
          name: "心脏病1",
          ItemList: [{ itemName: "心脏病类型2", age: "102人查看" }],
        },
        {
          name: "心脏病",
          ItemList: [{ itemName: "心脏病类型", age: "100人查看" }],
        },
        {
          name: "心脏病1",
          ItemList: [{ itemName: "心脏病类型2", age: "102人查看" }],
        },
        {
          name: "心脏病",
          ItemList: [{ itemName: "心脏病类型", age: "100人查看" }],
        },
        {
          name: "心脏病1",
          ItemList: [{ itemName: "心脏病类型2", age: "102人查看" }],
        },
        {
          name: "心脏病",
          ItemList: [{ itemName: "心脏病类型", age: "100人查看" }],
        },
        {
          name: "心脏病1",
          ItemList: [{ itemName: "心脏病类型2", age: "102人查看" }],
        },
        {
          name: "心脏病",
          ItemList: [{ itemName: "心脏病类型", age: "100人查看" }],
        },
        {
          name: "心脏病1",
          ItemList: [{ itemName: "心脏病类型2", age: "102人查看" }],
        },
        {
          name: "心脏病",
          ItemList: [{ itemName: "心脏病类型", age: "100人查看" }],
        },
        {
          name: "心脏病1",
          ItemList: [{ itemName: "心脏病类型2", age: "102人查看" }],
        },
      ],
      actived: 0,
    };
  },
  mounted() {
    this.getData()
  },
  beforeCreate() {
    document.title = "健康查一查"
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#ffffff");
  },
  methods: {
    
    xhjk() {
      window.location.href = 'https://m.xiaohe-jiankang.com/medical/disease/list/1?open_time=1716778545650&last_page_item_id='
    },
    see() {
      this.$router.push({
              path: "/see"
            });
    },
    details(item) {
      console.log(item)
      this.$router.push({
              path: "/screendetail",
              query:{
                name:item
              }
            });
    },
    getData() {
      document
      .querySelector("#app")
      .setAttribute("style", "background-color:#ffffff");
      medicalcanonv1info().then((res)=>{
        this.list = res.data
        console.log(res)
      })
    },
    toggle(index) {
      this.actived = index;
      // document.querySelector(".tab-content .wrapbox").style.webkitTransform = "translateX(-" + (this.actived * 400) + "px)";
    },
  },
};
</script>
<style scoped>
* {
  margin: 0 auto;
  padding: 0;
  font-family: "微软雅黑";
}
.clearboth::after {
  content: "";
  display: block;
  clear: both;
  color: #000000;
}
.tab-slider {
  display: flex;
  min-height: 94vh;
  width: 100%;
  /* margin-top: 5vw; */
  /* padding-top: 2vw; */
  border-top: 1px solid #f6f6f6;
  /* margin: 50px auto; */
}
.tab-slider .tab {
  height: 94vh;
    overflow: auto;
  width: 30%;
  /* display:flex; */
  /* height:40px; */
  line-height: 40px;
  background: #f6f6f6;
}
.tab-slider .tab span {
  display: block;
  width: 100%;
  text-align: center;
  cursor: default;
}
.tab-slider .tab .active {
  background: #ffffff;
  text-align: center;
  font-weight: 400;
  color: #000000 !important;
}
.tab-slider .tab-content {
  min-height: 94vh;
  height: 94vh;
    overflow: auto;
  width: 80%;
  /* overflow: hidden; */
}
.tab-slider .tab-content .item {
  float: left;
  /* height: 300px;
  width: 400px;
  line-height: 300px;
  text-align: center;
  font-size: 60px;
  background: #eee; */
}
.tab-slider .wrapbox {
  width: 100%;
  /* transition: all 1s; */
}
.search {
  position: relative;
    color: gray;
    border: 1px solid #f6f6f6;
    background-color: #f6f6f6;
    border-radius: 100px;
    height: 9vw;
    line-height: 5vw;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90%;
    margin: 2vw auto;
    overflow: hidden;
    padding: 0vw 20vw;
}

.search div {
  margin-left: 30px;
  margin-right: 30px;
}

input {
  margin-top: 1px;
  width: 100%;
  outline: none;
  border: none;
}

.icon {
  display: block;
  position: absolute;
  top: 5px;
  left: 10px;
  width: 20px;
  color: currentcolor;
  float: left;
}

.del {
  display: block;
  position: absolute;
  top: 5px;
  right: 10px;
  color: currentcolor;
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/views/screen.vue